import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const KeyboardIconIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_313_19493)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4127 2.26984H1.26984V13.0635H18.4127V2.26984ZM1.26984 1C0.568526 1 0 1.56853 0 2.26984V13.0635C0 13.7648 0.568526 14.3333 1.26984 14.3333H18.4127C19.114 14.3333 19.6825 13.7648 19.6825 13.0635V2.26984C19.6825 1.56853 19.114 1 18.4127 1H1.26984Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M2.53968 3.53968H4.44443V5.44445H2.53968V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M5.07935 3.53968H6.98411V5.44445H5.07935V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M7.61903 3.53968H9.52379V5.44445H7.61903V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M10.1587 3.53968H12.0635V5.44445H10.1587V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M12.6984 3.53968H14.6031V5.44445H12.6984V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M15.2381 3.53968H17.1428V5.44445H15.2381V3.53968Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M2.53968 6.71429H4.44443V8.61905H2.53968V6.71429Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M2.53968 9.88889H4.44443V11.7937H2.53968V9.88889Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M5.07935 6.71429H6.98411V8.61905H5.07935V6.71429Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M5.07935 9.88889H12.0635V11.7937H5.07935V9.88889Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M7.61903 6.71429H9.52379V8.61905H7.61903V6.71429Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M10.1587 6.71429H12.0635V8.61905H10.1587V6.71429Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M12.6984 9.88889H14.6031V11.7937H12.6984V9.88889Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M15.2381 9.88889H17.1428V11.7937H15.2381V9.88889Z"
          fill={fillColor || "#F6F6F7"}
        />
        <path
          d="M12.6984 6.71429H17.1428V8.61905H12.6984V6.71429Z"
          fill={fillColor || "#F6F6F7"}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_313_19493"
          x="0"
          y="0"
          width="19.6826"
          height="14.3335"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_313_19493"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_313_19493"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export { KeyboardIconIcon };
